import { useState } from 'react'
import styled from '@emotion/styled'
import { Avatar, Box } from '@mui/material'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import { COLORS } from 'app-constants'

const Image = styled.img`
  display: inline-block;
  border-radius: 50%;
  object-fit: cover;
`

function avatarProps(size: string | number, name?: string) {
  let initials = ''

  if (name) {
    const split = name.split(' ')
    initials = name[0]
    if (split.length > 1) {
      initials = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
    }
  }

  // The inner svg is used to scale text according to the size of the avatar.
  return {
    sx: {
      bgcolor: COLORS.JELLED_PRIMARY_BLUE,
      width: size,
      height: size,
    },
    children: (
      <svg viewBox={`0 0 96 96`} style={{ width: '100%' }}>
        <text
          x="50%"
          y="50%"
          dy={4} /* Small visual adjustment to appear more centered. */
          style={{
            fontWeight: 700,
            fontSize: '40px',
            textAnchor: 'middle',
            dominantBaseline: 'middle',
            fill: 'white',
          }}>
          {initials.toUpperCase()}
        </text>
      </svg>
    ),
  }
}

const ProfilePhoto = ({
  src,
  size,
  name,
  hasOutline,
}: {
  src?: string
  size: string | number
  name?: string
  hasOutline?: boolean
}) => {
  const [didFail, setDidFail] = useState(false)
  const onError = () => {
    setDidFail(true)
  }

  if (!src && !name) {
    return (
      <Avatar sx={{ bgcolor: COLORS.JELLED_PRIMARY_BLUE, width: size, height: size }}>
        <AccountCircleOutlinedIcon sx={{ width: 1 / 2, height: 1 / 2 }} />
      </Avatar>
    )
  }

  const useFallback = didFail || !src

  if (useFallback) {
    return <Avatar {...avatarProps(size, name)} />
  }

  return (
    <Box sx={{ width: size, height: size, borderRadius: size, outline: hasOutline ? '1px solid #dddddd' : 'none' }}>
      <Image src={src} alt="Profile" loading="lazy" style={{ width: size, height: size }} onError={onError} />
    </Box>
  )
}

export default ProfilePhoto
